import EntradaCompraService from "@/services/inventario/EntradaCompraService";

const fetch = (context, params) => {
  return EntradaCompraService.fetch(params)
    .then(res => {
      context.commit('ENTRADAS_COMPRA', res.data);
    });
};

export default {
  fetch,
};